import { render } from "./BooksIcon.vue?vue&type=template&id=394f79f3"
import script from "./BooksIcon.vue?vue&type=script&lang=js"
export * from "./BooksIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ramazansapar/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__